import type { RouteLocationNormalizedLoaded, Router } from "vue-router";

// Полноэкранный поиск телефона - своя запись истории браузера с отметкой в
// history.state (тот же приём, что ecoCard в useSearchNavigation): «назад»
// браузера / жест Android закрывает поиск, а не уходит со страницы карты.
// - Открытие: pushSearchEntry (на записи с отметкой - без второй, например
//   после перезагрузки на ней же).
// - «Назад» с этой записи: useSearchNavigation видит уход с отметки и вызывает
//   session.cancel().
// - Закрытие иначе («Отмена») - leaveSearchEntry: router.back(), без мёртвой
//   записи; «Все маршруты» - replace поверх неё (replaceOrPush).
// - Карточка, открытая из поиска, кладётся поверх (ecoCard.overSearch), её
//   «Назад» возвращает на эту запись, consumeReturn() открывает поиск без нового push.
export const SEARCH_ENTRY_STATE = "ecoSearch";

export const onSearchEntry = (router: Router): boolean => {
  // Тесты подменяют роутер урезанным моком без options.
  const state = router.options?.history?.state as Record<string, unknown> | undefined;
  return !!state?.[SEARCH_ENTRY_STATE];
};

export const pushSearchEntry = (router: Router, route: RouteLocationNormalizedLoaded) => {
  if (onSearchEntry(router)) return;
  // force: тот же адрес (/map) - без него vue-router сочтёт переход дублем и не положит запись.
  return router.push({ path: route.path, query: route.query, hash: route.hash, state: { [SEARCH_ENTRY_STATE]: true }, force: true });
};

export const leaveSearchEntry = (router: Router) => {
  if (onSearchEntry(router)) router.back();
};

// Переход из открытого поиска (каталог): запись поиска заменяется, не остаётся
// позади. Отметку снимаем явно: web-история vue-router при replace сливает
// новое state со старым.
export const replaceOrPush = (router: Router, to: string) => {
  if (!onSearchEntry(router)) return router.push(to);
  const r = router.resolve(to);
  return router.replace({ path: r.path, query: r.query, hash: r.hash, state: { [SEARCH_ENTRY_STATE]: false } });
};
